import React, { useMemo, type ReactNode } from 'react';
// eslint-disable-next-line no-restricted-imports -- Retains the floating banner control cohort.
import { Subscribe } from 'unstated';

import { expValEquals } from '@confluence/feature-experiments';

import type { BannerStateInfo } from './BannerStateContainer.ts';
import { FloatingBannerStateContainer } from './FloatingBannerStateContainer.ts';
import { useFloatingBannerHeight } from './useFloatingBannerState.ts';

export type FloatingBannerHeightState = { getFloatingHeight: () => number };
export type FloatingBannerEntriesState = { state: { floatingBanners: readonly BannerStateInfo[] } };

type HeightProps = { children: (state: FloatingBannerHeightState) => ReactNode };
const CONTAINERS = [FloatingBannerStateContainer];

const FloatingBannerHeightReaderWithHooks = ({ children }: HeightProps): React.JSX.Element => {
	const height = useFloatingBannerHeight();
	const state = useMemo(() => ({ getFloatingHeight: () => height }), [height]);
	return <>{children(state)}</>;
};

export const FloatingBannerHeightReader = ({ children }: HeightProps): React.JSX.Element => {
	if (expValEquals('confluence_banner_store_migration', 'isEnabled', true)) {
		return <FloatingBannerHeightReaderWithHooks>{children}</FloatingBannerHeightReaderWithHooks>;
	}
	return (
		<Subscribe to={CONTAINERS}>
			{(state: FloatingBannerStateContainer) => <>{children(state)}</>}
		</Subscribe>
	);
};
